import { IProfile } from '@jumpstart/core';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { IServiceOption, PRODUCTION_SERVICE_OPTIONS, TEST_SERVICE_OPTIONS } from './services/service-options';

export interface IServicePaymentMessage {
  subscriberProfile: IProfile;
  onSubmit(service: IServiceOption): void;
}

export default function ServicePaymentMessage(props: IServicePaymentMessage) {
  const {subscriberProfile, onSubmit} = props;
  const [value, setValue] = useState<null | IServiceOption>(null);
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = () => {
    if (value) {
      onSubmit(value);
    }
  }

  return (
    <Grid
      container
      direction="column"
      sx={{
        '& > :not(:last-child)': {
          marginBottom: 4
        }
      }}
    >
      <Autocomplete
        onChange={(event: any, newValue: IServiceOption | null) => {
          setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        id="service-options"
        options={process.env.NODE_ENV === 'production' ? PRODUCTION_SERVICE_OPTIONS : TEST_SERVICE_OPTIONS}
        getOptionLabel={(option) => option.name}
        sx={{ width: 300 }}
        renderOption={(props, option: IServiceOption) =>
          // <ListItem disablePadding={false} component="li">
          //   <ListItemText
          //     primary={option.name}
          //     secondary={`$${option.amount/100} - ${option.description}`}
          //   />
          // </ListItem>
          <Grid component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} container direction="column" {...props}>
            <Typography variant="body1">{option.name}</Typography>
            <Typography variant="caption">${option.amount/100} - {option.description}</Typography>
          </Grid>
        }
        renderInput={(params) => <TextField {...params} label="Service" />}
      />


      <Grid
        container
        direction="column"
        sx={{
          '& > :not(:last-child)': {
            marginBottom: 2
          }
        }}
      >
      {value && <Typography variant="subtitle1">Render Service to {subscriberProfile.firstName ? subscriberProfile.firstName : 'user'}?</Typography>}
      {value && <Card sx={{ minWidth: 275 }} elevation={3}>
        <CardContent>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            {value.description}
          </Typography>
          <Typography variant="h5" component="div">
            {value.name}
          </Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            ${value.amount/100} ({value.currency})
          </Typography>
        </CardContent>
      </Card>}
      </Grid>

      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Button variant="contained" disabled={!value} onClick={handleSubmit} sx={{marginBottom: 2}}>Send</Button>
        {value && <Typography variant="caption">This will charge the customer ${value.amount/100} to their card</Typography>}
      </Grid>
    </Grid>
  )
}
